import bodymovin from 'bodymovin';
import careersPieAnimation from '../../assets/lottie/careers-pie.json';
import Flickity from 'flickity';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const fly_tabs: LegacyModule = {
	active: false,
	$tab_controls: document.getElementsByClassName('fly-tab-control'),
	$tabs: document.getElementsByClassName('fly-tab'),
	init: function () {
		var self = this;
		self.resize();
		self.toggle();
		self.navigate();
	},
	build: function () {
		var self = this;
		self.unset_classes();
		self.$tab_controls[0].classList.add('active');
		self.$tabs[0].classList.add('active');
	},
	destroy: function () {
		var self = this;
		self.unset_classes();
	},
	navigate: function () {
		var self = this;
		for (var i = 0; i < self.$tab_controls.length; i++) {
			self.$tab_controls[i].addEventListener('click', fly_tabs.update);
		}
	},
	unset_classes: function () {
		var self = this;
		for (var i = 0; i < self.$tab_controls.length; i++) {
			self.$tab_controls[i].classList.remove('active');
		}
		for (var j = 0; j < self.$tabs.length; j++) {
			self.$tabs[j].classList.remove('active');
		}
	},
	update: function (e) {
		e.preventDefault();
		fly_tabs.unset_classes();
		this.classList.add('active');
		var slug = this.getAttribute('href').split('#').pop();
		var $targ = document.getElementById(slug);
		$targ.classList.add('active');
	},
	resize: function () {
		window.addEventListener('resize', fly_tabs.resize_request);
	},
	resize_request: function () {
		window.requestAnimationFrame(fly_tabs.toggle);
	},
	toggle: function () {
		if (window.innerWidth >= 768 && fly_tabs.active === false) {
			fly_tabs.active = true;
			fly_tabs.build();
		} else if (window.innerWidth < 768 && fly_tabs.active === true) {
			fly_tabs.active = false;
			fly_tabs.destroy();
		}
	},
};

if (document.getElementsByClassName('js-module-tabs').length > 0) {
	fly_tabs.init();
}

const fly_careers: LegacyModule = {
	$cont: document.querySelector('#fly-section-spirit .rotator'),
	$fly_pie: document.getElementById('fly-pie'),
	$circ: document.querySelector('.fly-pie-wrapper .circle'),
	init: function () {
		this.rotator();
		if (this.$fly_pie) {
			this.create_animation();
			this.scroll_trigger();
		}
	},
	rotator: function () {
		var _flkty = new Flickity(this.$cont, {
			contain: true,
			imagesLoaded: true,
			wrapAround: true,
			arrowShape:
				'M61.1,72.8c0.8,0,1.6-0.3,2.1-0.9c1-1.2,0.9-3-0.2-4L43.2,50.2l19.7-18.1c1.2-1.1,1.2-2.9,0.2-4C62,27,60.2,26.9,59,28 L37,48.2c-0.6,0.5-0.9,1.3-0.9,2.1c0,0.8,0.4,1.6,0.9,2.1l22.1,19.7C59.7,72.5,60.4,72.8,61.1,72.8z',
		});
	},

	create_animation: function () {
		var animData = {
			animType: 'svg',
			autoplay: false,
			loop: false,
			animationData: careersPieAnimation,
			prerender: true,
			wrapper: this.$fly_pie,
		};
		this.pie_anim = bodymovin.loadAnimation(animData);
		bodymovin.setSubframeRendering(false);
	},

	trigger_anim: function (_e) {
		this.pie_anim.play();
		setTimeout(
			function ($el) {
				$el.classList.add('active');
			},
			500,
			this.$circ
		);
	},

	reset_anim: function (_e) {
		this.pie_anim.goToAndStop(0, true);
		this.$circ.classList.remove('active');
	},

	scroll_trigger: function () {
		ScrollTrigger.create({
			trigger: '#fly-pie',
			start: 'top 70%',
			end: 'bottom 30%',
			onEnter: () => this.trigger_anim(),
		});

		ScrollTrigger.create({
			trigger: '.profit-share',
			onLeaveBack: () => this.reset_anim(),
		});
	},
};

if (fly_careers.$cont) {
	fly_careers.init();
}
